export default () => ({
	searchTerm: '',
	results: [],
	isLoading: false,

	search() {
		window.location.href = window.routes.search.replace('%s', this.searchTerm)
	},
})
